/* tslint:disable */
/* eslint-disable */
export enum WorkProjectSharePublicUploadKindEnum {
  Photo = 'PHOTO',
  Document = 'DOCUMENT'
}
